import { brand } from '@websrc/App/Helpers/brand'
import clsx from 'clsx'
import { styles } from 'leds'
import React from 'react'

export type WithBrandProps = {
  title: string
  className?: string
}

export const WithBrand = ({ title, className }: WithBrandProps) => (
  <>
    {title
      .split(/({brand})/g)
      .filter(Boolean)
      .map((words) =>
        words === '{brand}' ? (
          <span className={clsx(styles({ whiteSpace: 'nowrap' }), className)} key={words}>
            {brand.name}
          </span>
        ) : (
          <span className={className} key={words}>
            {words}
          </span>
        )
      )}
  </>
)
